import Head from "next/head";
import * as S from "./Travel.styles";
import * as H from "../../styles/Headings";

export default function Travel() {
  return (
    <>
      <Head>
        <meta
          name="description"
          property="og:description"
          content="Travelling details for Chloë and David's wedding"
        />
        <title>Travel • David &amp; Chloë</title>
      </Head>

      <S.Container>
        <H.H2>Vehicle</H.H2>
        <p>
          The best way is to use your (Google) Maps mobile application to travel
          to
        </p>

        <S.Address>
          <a
            href="https://g.page/DoubleTreeHarrogateMajestic"
            target="_blank"
            rel="noopener noreferrer"
          >
            DoubleTree by Hilton Harrogate Majestic Hotel &amp; Spa
            <br />
            Harrogate, HG1 2HU
          </a>
        </S.Address>

        <S.Map
          title="Location of Hotel - Google Maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2345.334802073341!2d-1.545904183646058!3d53.996832633487564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48795337c2235353%3A0xb14edc9db646ae49!2sDoubleTree%20by%20Hilton%20Harrogate%20Majestic%20Hotel%20%26%20Spa!5e0!3m2!1sen!2suk!4v1625609172215!5m2!1sen!2suk"
          allow="fullscreen"
          loading="lazy"
        />

        <p>
          If you are coming up by vehicle from the South, we recommend that you
          take the M1 rather than the A1(M) for most of the journey as it is an
          easier drive.
        </p>

        <H.H2>Trains</H.H2>
        <H.H3>London</H.H3>
        <p>
          From Kings Cross you can get to Harrogate between 2 hours 30 minutes
          and 3 hours. You will usually have to change at Leeds. Prices are
          cheaper if you book in advance. Tickets can be purchased at{" "}
          <a
            href="https://www.thetrainline.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            The Train Line
          </a>
          .
        </p>

        <H.H3>Manchester</H.H3>
        <p>
          There is a train that goes from Manchester Airport/Piccadilly to
          Harrogate with a transfer at Leeds. Prices are cheaper if you book in
          advance. Tickets can be purchased at{" "}
          <a
            href="https://www.thetrainline.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            The Train Line
          </a>
          .
        </p>

        <H.H2>Flights</H.H2>
        <p>
          For international travelers, the closest airport to the venue is Leeds
          Bradford International (LBA), although it might be easier to find a
          flight to London (LHR, LGW or LTN) or Manchester (MAN) and then get a
          train from London Kings Cross or Manchester Airport.
        </p>
        <H.H3>Luton to Kings Cross</H.H3>
        <p>
          There is a shuttle bus that goes from Luton Airport to the train at
          the Luton Airport Parkway. The Thameslink train service goes from
          Luton Airport Parkway to St Pancras, which is next to Kings Cross. It
          costs about £15 and takes about 30 minutes. Tickets are available at{" "}
          <a
            href="https://ticket.thameslinkrailway.com/search"
            target="_blank"
            rel="noopener noreferrer"
          >
            The Thameslink Website
          </a>
          .
        </p>
        <H.H3>Gatwick to Kings Cross</H.H3>
        <p>
          The Thameslink train service goes from Gatwick to St Pancras, which is
          next to Kings Cross. It costs about £15 and takes about 40 minutes.
          Tickets are available at{" "}
          <a
            href="https://ticket.thameslinkrailway.com/search"
            target="_blank"
            rel="noopener noreferrer"
          >
            The Thameslink Website
          </a>
          .
        </p>
        <H.H3>Heathrow to Kings Cross</H.H3>
        <p>
          The easiest option is to take a taxi, which have plenty of room for
          luggage. However, it will be quite expensive, probably around £80.
        </p>
        <p>
          The Heathrow Express train to Paddington is another option, then you
          can take a taxi to Kings Cross, which is only a short journey.
          However, it&apos;s £34 return each so for multiple people this might
          not be cheaper than just getting a taxi. Tickets can be purchased at{" "}
          <a
            href="https://www.heathrowexpress.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            the Heathrow Express website
          </a>
          .
        </p>
        <p>
          The cheapest option would be the tube, which will cost £5.50 per
          person each way - assuming you are paying cash (you can save money if
          you get an Oyster card (or use a contactless payment card), which
          drops the price to £3 or £5 depending on the time of day). Take the
          Piccadilly line the whole way from Heathrow to Kings Cross.
        </p>
      </S.Container>
    </>
  );
}
